import {useState, useEffect} from "react";
import {isSyncEnabled} from "../pages/generic/crud";

/**
 * Custom hook to check if an entity is sync-enabled and get its sync capabilities.
 *
 * @param {number} entityId - The entity type ID to check
 * @returns {object} - { syncEnabled: boolean, pushEnabled: boolean, pullEnabled: boolean, loading: boolean }
 */
export function useSyncEnabled(entityId) {
    const [syncEnabled, setSyncEnabled] = useState(false);
    const [pushEnabled, setPushEnabled] = useState(false);
    const [pullEnabled, setPullEnabled] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;

        const checkSyncEnabled = async () => {
            try {
                setLoading(true);
                const response = await isSyncEnabled(entityId);
                if (mounted) {
                    setSyncEnabled(response.data.syncEnabled === true);
                    setPushEnabled(response.data.pushEnabled === true);
                    setPullEnabled(response.data.pullEnabled === true);
                }
            } catch (error) {
                console.error("Error checking sync enabled:", error);
                if (mounted) {
                    setSyncEnabled(false);
                    setPushEnabled(false);
                    setPullEnabled(false);
                }
            } finally {
                if (mounted) {
                    setLoading(false);
                }
            }
        };

        if (entityId) {
            checkSyncEnabled();
        } else {
            setLoading(false);
            setSyncEnabled(false);
            setPushEnabled(false);
            setPullEnabled(false);
        }

        return () => {
            mounted = false;
        };
    }, [entityId]);

    return {syncEnabled, pushEnabled, pullEnabled, loading};
}
